import { render, staticRenderFns } from "./Cascader.vue?vue&type=template&id=90c8354e&scoped=true&"
import script from "./Cascader.vue?vue&type=script&lang=js&"
export * from "./Cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c8354e",
  null
  
)

export default component.exports